export default __webpack_public_path__ + "static/media/xbusd-logo-ellipse-transparent-260x260.a0543b50.svg";